export interface Stat {
  label: string;
  count: number;
  change?: number;
  previousCount?: number;
  showPreviousCount?: boolean;
}

export enum SearchState {
  NotStarted,
  Loading,
  NoResults,
  ResultsFound,
}

export interface TableColumn {
  name: string;
  order: number;
  type: string;

  visible?: boolean;
  width?: string;
  maxLines?: number;
  truncate: boolean;
  expanded?: boolean;
  [key: string]: any;
}

export interface Role {
  label: string;
  value: string;
}

export const roles: Role[] = [
  { label: 'Admin', value: 'admin' },
  { label: 'OSD', value: 'osd' },
  { label: 'OSD Beta 1', value: 'osd-beta-1' },
  { label: 'OSD Beta 2', value: 'osd-beta-2' },
  { label: 'Supply', value: 'supply' },
  { label: 'PavCon', value: 'pavcon' },
];
export interface MenuItem {
  title: string;
  icon: string;
  link: string | null;
  isDisabled: boolean;
}
